import { Skeleton } from "@mui/material";

export default function TableSkeleton() {
  return (
    <div style={{ width: "100%" }}>
      <Skeleton animation="wave" height={60} />
      <Skeleton animation="wave" height={60} />
      <Skeleton animation="wave" height={60} />
      <Skeleton animation="wave" height={60} />
    </div>
  );
}
